<div>
  <app-room-tag [title]="room.type" [textColor]="'#fff'" [color]="getRoomTypeColor()"></app-room-tag>
  <app-room-tag *ngFor="let tag of room.tags" [title]="tag.tag"></app-room-tag>
</div>

